export default __webpack_public_path__ + "static/media/best-doc-logo.deaa0c5e.png";